export type BatchAnimalFilter = 'all' | 'female';

export type BatchSessionField =
  | 'bull_id'
  | 'is_pregnant'
  | 'treatment_kind'
  | 'product_name'
  | 'dose'
  | 'route'
  | 'product_batch'
  | 'next_dose_date'
  | 'milking_shift';

export type BatchEventTypeConfig = {
  value: string;
  label: string;
  animalFilter: BatchAnimalFilter;
  /** Campos por linha na tabela */
  rowFields: ('weight_kg' | 'include')[];
  /** Campos no cabeçalho da sessão */
  sessionFields?: BatchSessionField[];
  hint?: string;
};

export const BATCH_EVENT_TYPES: BatchEventTypeConfig[] = [
  {
    value: 'weighing',
    label: 'Pesagem',
    animalFilter: 'all',
    rowFields: ['weight_kg'],
  },
  {
    value: 'weaning',
    label: 'Desmame',
    animalFilter: 'all',
    rowFields: ['include', 'weight_kg'],
    hint: 'Marque os desmamados; peso é opcional',
  },
  {
    value: 'milk_weighing',
    label: 'Pesagem de leite',
    animalFilter: 'female',
    rowFields: ['weight_kg'],
    sessionFields: ['milking_shift'],
    hint: 'Informe o turno da sessão e os litros por vaca',
  },
  {
    value: 'natural_mount',
    label: 'Monta natural',
    animalFilter: 'female',
    rowFields: ['include'],
    sessionFields: ['bull_id'],
    hint: 'Marque as vacas cobertas nesta sessão',
  },
  {
    value: 'insemination',
    label: 'Inseminação',
    animalFilter: 'female',
    rowFields: ['include'],
    sessionFields: ['bull_id'],
    hint: 'Marque as vacas inseminadas nesta sessão',
  },
  {
    value: 'pregnancy_diagnosis',
    label: 'Diagnóstico gestação',
    animalFilter: 'female',
    rowFields: ['include'],
    sessionFields: ['bull_id', 'is_pregnant'],
    hint: 'Marque as vacas diagnosticadas nesta sessão',
  },
  {
    value: 'medication',
    label: 'Medicação / Vacinação',
    animalFilter: 'all',
    rowFields: ['include'],
    sessionFields: [
      'treatment_kind',
      'product_name',
      'dose',
      'route',
      'product_batch',
      'next_dose_date',
    ],
    hint: 'Informe o produto da sessão e marque os animais tratados',
  },
];

export function batchEventLabel(value: string): string {
  return BATCH_EVENT_TYPES.find((t) => t.value === value)?.label ?? value;
}
